<div class="db-test-mode-confirmation">
  <h1>{{'text_boosterTestModeTitle' | dbText}}</h1>
  <p class="mt10" [innerHTML]="'text_boosterTestModeTitleDescription1' | dbText"></p>
    <p class="mt22"><a class="semibold" (click)="openKnowledgeBase()" [innerHTML]="'text_boosterTestModeTitleDescription2' | dbText"></a> <span [innerHTML]="'text_boosterTestModeTitleDescription3' | dbText"></span></p>
  <div class="db-test-mode-confirmation__buttons mt30">
    <button class="ds-btn mr20" (click)="close()" [ngClass]="{'ds-btn-disabled': loading}"><span>{{'text_cancel' | dbText}}</span></button>
    <button class="ds-btn-blue" (click)="confirm()" [ngClass]="{'ds-btn-disabled': loading}">
      <span *ngIf="!loading">{{'text_enable' | dbText}}</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </button>
  </div>
</div>
